import {
  Box,
  Button,
  Stack,
  styled,
  Typography,
  Grid,
  Checkbox,
  FormControlLabel,
  Select,
  Dialog,
  DialogContent,
  DialogActions,
  useMediaQuery,
} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import React, { useEffect, useState } from "react";
import CommonTable1 from "app/components/Tables/CommonTable1";
import DialogHeader from "app/components/common/DialogHeader";
import { CustomTextField } from "assets/styles/globalStyledComponent";
import { useMutation, useQuery } from "react-query";
import {
  getBooksForSale,
  updateBookQuantity,
} from "app/services/ledgerAccount";
import { toast } from "react-toastify";
import { LoadingButton } from "@mui/lab";
import {
  IndianCurrency,
} from "app/utils/helper";
import CustomLoader from "app/components/common/CustomLoader";
import TextFieldLabel from "app/components/common/TextFieldLabel";
import ExportButtonGroup from "app/components/common/ExportButtonGroup";
import UniversalExportDialog from "app/components/common/Dialogs/UniversalExportDialog";
import CommonFilterDialog from "app/components/common/Dialogs/CommonFilterDialog";
import CommonDialog from "app/components/common/Dialogs/CommonDialog";
import FilterButton from "app/components/common/FilterButton";
import { useSelector } from "react-redux";
import {
  selectActiveSession,
} from "app/modules/schools/selectors";
import UpdateBookRateDialog from "./UpdateBookRateDialog";
import ByClassFilter from "app/components/commonSeperateMultipleFilter/ByClassFilter";
import { Helmet } from "react-helmet";
import BuyBookDialog from "app/components/common/Dialogs/ledger/books/BuyBookDialog";
import { useClassData } from "app/hooks/globallyApplicable/useClassData";

const IncreaseDecreaseDialog = ({ open, handleClose, refetch, bookDocId }) => {
  const [state, setState] = useState({
    bookQuantity: "",
  });
  const onClose = () => {
    handleClose();
    setState((prev) => ({
      ...prev,
      bookQuantity: "",
    }));
  };
  const handleSubmitIncreaseDecrease = (e) => {
    e.preventDefault();
    updateBookQuantityMutate({
      quantity: state.bookQuantity,
      bookDocId,
    });
  };
  const {
    mutate: updateBookQuantityMutate,
    isLoading: updateBookQuantityLoading,
  } = useMutation(updateBookQuantity, {
    onSuccess: (res) => {
      refetch();
      onClose();
      toast.success(res?.data?.message);
    },
    onError: (err) => {
      toast.error(err?.response?.data?.message);
    },
  });

  return (
    <CommonDialog
      open={open}
      title="Increase/Decrease Books"
      onClose={onClose}
      minWidth="450px"
    >
      <DialogContent>
        <form
          id="increase-decrease-book-form"
          onSubmit={handleSubmitIncreaseDecrease}
        >
          <TextFieldLabel title={"Increase Decrease Quantity"} />
          <CustomTextField
            placeholder="Type quantity"
            required
            value={state.bookQuantity}
            size="small"
            sx={{ width: "100%" }}
            type="number"
            onChange={(e) =>
              setState((prev) => ({ ...prev, bookQuantity: e.target.value }))
            }
          />
          <Typography sx={{ opacity: 0.7, my: 0.5, fontSize: "14px" }}>
            For Decrease use minus sign before quantity (ex. -10)
          </Typography>
        </form>
      </DialogContent>
      <DialogActions>
        <LoadingButton
          loading={updateBookQuantityLoading}
          type="submit"
          variant="contained"
          color="secondary"
          size="large"
          form="increase-decrease-book-form"
        >
          Submit
        </LoadingButton>
      </DialogActions>
    </CommonDialog>
  );
};
const BookSummary = () => {
  const selectedActiveSession = useSelector(selectActiveSession);
  const isMobile = useMediaQuery("(max-width: 768px)");
  const [openCheckBox, setOpenCheckBox] = useState(false);
  const [state, setState] = useState({
    addBookDialog: false,
    tableData: [],
    selectedClass: "",
    selectedSeller: "",
    customize: {
      class: "",
      section: "",
      gName: "",
      bookList: [],
    },
    image: {
      link: "",
      file: null,
    },
    section: "",
    bookQuantity: 0,
    bookQuantityDialog: false,
    bookDocId: "",
    filterExtraData: false,
    checkExportOptionsPdf: false,
    filterData: {},
  });
  const [modalOpen, setModalOpen] = useState(false);
  const [dialogs, setDialogs] = useState({
    add: false,
    book: false,
    view: false,
    editRate: false,
    editRateData: {},
  });

  const [checkboxes, setCheckboxes] = useState({
    one: false,
  });

  const columns = [
    {
      header: "Sr.No",
      Cell: ({
        cell: {
          row: { id },
        },
      }) => (
        <Typography>
          {parseInt(id) + 1 < 10 ? `0${parseInt(id) + 1}` : parseInt(id) + 1}
        </Typography>
      ),
      maxSize: isMobile ? 40 : 30,
    },
    {
      header: "Class-Stream",
      accessorKey: "stream",
      Cell: ({
        cell: {
          row: { original },
        },
      }) => {
        return <Typography>{original?.stream}</Typography>;
      },
      maxSize: isMobile ? 60 : 40,
    },
    {
      header: "Book Title",
      accessorKey: "title",
      Cell: ({
        cell: {
          row: { original },
        },
      }) => {
        return <Typography>{original?.title}</Typography>;
      },
      maxSize: isMobile ? 60 : 40,
    },
    {
      header: "Bought Qty",
      accessorKey: "qty",
      Cell: ({
        cell: {
          row: { original },
        },
      }) => {
        return (
          <Typography
            onClick={() =>
              setState((prev) => ({
                ...prev,
                bookQuantityDialog: true,
                bookDocId: original?.id,
              }))
            }
            sx={{
              cursor: "pointer",
              textDecoration: "underline",
              color: "#2789FD",
            }}
          >
            {original?.bqty}
          </Typography>
        );
      },
      maxSize: isMobile ? 60 : 40,
    },
    {
      header: "Expense Amount",
      accessorKey: "eamount",
      Cell: ({
        cell: {
          row: { original },
        },
      }) => {
        return <Typography>{original?.expenseAmount}</Typography>;
      },
      maxSize: isMobile ? 60 : 40,
    },
    {
      header: "Sold Qty",
      accessorKey: "sqty",
      Cell: ({
        cell: {
          row: { original },
        },
      }) => {
        return <Typography>{original?.soldQuantity}</Typography>;
      },
      maxSize: isMobile ? 60 : 40,
    },

    {
      header: "Balance Qty",
      accessorKey: "bqty",
      Cell: ({
        cell: {
          row: { original },
        },
      }) => {
        return <Typography>{original?.balanceQuantity}</Typography>;
      },
      maxSize: isMobile ? 60 : 40,
    },
    {
      header: "Created By",
      accessorKey: "created",
      Cell: ({
        cell: {
          row: { original },
        },
      }) => {
        return <Typography>{original?.created}</Typography>;
      },
      maxSize: isMobile ? 60 : 40,
    },
    {
      header: "Actions",
      Cell: ({ cell }) => {
        return (
          <Stack direction="row" gap={2}>
            <button
              style={{
                backgroundColor: "#EBF0F4",
                borderRadius: "8px",
                border: "none",
                outline: "none",
                width: "2.5rem",
                height: "2.5rem",
                color: "#6197ed",
              }}
              onClick={() => {
                setDialogs((prev) => ({ ...prev, view: true }));
                setState((prev) => ({
                  ...prev,
                  active: cell?.row?.original?.data,
                }));
              }}
            >
              <VisibilityIcon />
            </button>
          </Stack>
        );
      },
      size: isMobile ? 40 : 20,
    },
  ];

  const tableData = state?.tableData?.map((item) => {
    return {
      data: item,
      stream:
        item?.className + "-" + item?.stream || "--" + item?.section || "--",
      title: item?.bookTitle || "--",
      bqty: item?.quantity || "--",
      expenseAmount: item?.expenseAmount,
      soldQuantity: item?.soldQuantity || 0,
      balanceQuantity: item?.balanceQuantity,
      created: item?.createdBy?.personName || "--",
      id: item?._id,
      amount: item?.amount ?? "--",
      status: item?.status ?? "--",
      paid_By: item?.paidBy?.personName ?? "--",
    };
  });
  const [selectedClasses, setSelectedClasses] = useState([]);
  const [classListToMutate, setClassListToMutate] = useState([]);
  const {
    refetch: getBooksForSaleRefetch,
    isLoading: getBooksForSaleLoading,
    isFetching: getBooksForSaleFetching,
  } = useQuery({
    queryKey: ["getBooksForSale", selectedActiveSession],
    queryFn: () =>
      getBooksForSale({
        session: selectedActiveSession,
        ...(checkboxes.one &&
          classListToMutate.length > 0 && {
            classList: JSON.stringify(classListToMutate),
          }),
      }),
    onSuccess: (res) => {
      setState((prev) => ({ ...prev, tableData: res?.data?.list }));
    },
    onError: (err) => {
      toast.error(err?.response?.data?.message);
    },
  });

  const handleCloseFilterDialog = () => {
    setModalOpen(false);
  };
  let header = [
    "ClassName",
    "Book_Title",
    "Expense_Amount",
    "Balance_Quantity",
    "Bought_Quantity",
    "Sold_Quantity",
    "Created_By",
  ];

  let exportArray = tableData?.map((item) => {
    return {
      ClassName: item?.stream,
      Book_Title: item?.title,
      Expense_Amount: item?.expenseAmount ?? "--",
      Balance_Quantity: item?.balanceQuantity ?? "--",
      Bought_Quantity: item?.bqty ?? "--",
      Sold_Quantity: item?.soldQuantity ?? "--",
      Created_By: item?.created ?? "--",
    };
  });

  // PDF data preparation
  let headerPdf = [
    "ClassName",
    "Book_Title",
    "Expense_Amount",
    "Balance_Quantity",
    "Bought_Quantity",
    "Sold_Quantity",
    "Created_By",
  ];

  let exportArrayPdf = tableData?.map((item) => {
    return {
      ClassName: item?.stream ?? "--",
      Book_Title: item?.title ?? "--",
      Expense_Amount: item?.expenseAmount ?? "--",
      Balance_Quantity: item?.balanceQuantity ?? "--",
      Bought_Quantity: item?.bqty ?? "--",
      Sold_Quantity: item?.soldQuantity ?? "--",
      Created_By: item?.created ?? "--",
    };
  });

  useEffect(() => {
    const filteredList = selectedClasses?.map(({ classDocId, section }) => ({
      classDocId,
      section,
    }));
    setClassListToMutate(filteredList);
  }, [selectedClasses]);

  const { classList: getClassDropdownData, error: getClassDropdownDataError } =
    useClassData();
  useEffect(() => {
    if (getClassDropdownDataError) {
      toast.error(getClassDropdownDataError?.message);
    }
    if (getClassDropdownData) {
      setState((prev) => ({ ...prev, classData: getClassDropdownData }));
    }
  }, [getClassDropdownData, getClassDropdownDataError]);

  const handleEditRateDialog = (data) => {
    setDialogs((prev) => ({ ...prev, editRate: true, editRateData: data }));
  };
  return (
    <>
      <Helmet>
        <title>Books | Summary</title>
      </Helmet>
      <CustomLoader show={getBooksForSaleLoading || getBooksForSaleFetching} />

      {/* Universal Export Dialog - Excel */}
      <UniversalExportDialog
        open={openCheckBox}
        onClose={() => setOpenCheckBox(false)}
        exportType="excel"
        excelHeaders={header}
        excelData={exportArray}
        fileName="Book_Summary"
        showSelectAll={true}
        showOrientation={false}
        showSchoolHeader={true}
      />

      {/* Universal Export Dialog - PDF */}
      <UniversalExportDialog
        open={state.checkExportOptionsPdf}
        onClose={() =>
          setState((prev) => ({ ...prev, checkExportOptionsPdf: false }))
        }
        exportType="pdf"
        pdfHeaders={headerPdf}
        pdfData={exportArrayPdf}
        fileName="Book_Summary"
        showSelectAll={true}
        showOrientation={true}
        showSchoolHeader={true}
      />

      <UpdateBookRateDialog
        open={dialogs?.editRate}
        onClose={() =>
          setDialogs((prev) => ({ ...prev, editRate: false, view: false }))
        }
        refetch={getBooksForSaleRefetch}
        data={dialogs?.editRateData}
      />

      {/* filter modal */}
      <CommonFilterDialog
        handleSaveAndView={() => {
          getBooksForSaleRefetch();
          handleCloseFilterDialog();
        }}
        open={modalOpen}
        onClose={handleCloseFilterDialog}
        title="Filter"
        minWidth="450px"
      >
        <DialogContent>
          <Stack>
            <FormControlLabel
              control={
                <Checkbox
                  checked={checkboxes.one}
                  onClick={() => {
                    setCheckboxes((prev) => ({ ...prev, one: !prev.one }));

                    checkboxes.one === true &&
                      setState((prev) => ({
                        ...prev,
                        selectedClass: "",
                        section: "",
                      }));
                  }}
                />
              }
              label="Class info"
            />
            {checkboxes.one && (
              <Stack direction="row" alignItems="center" spacing={2}>
                <ByClassFilter
                  prevClassList={selectedClasses}
                  setSelectedClasses={setSelectedClasses}
                />
              </Stack>
            )}
          </Stack>
        </DialogContent>
      </CommonFilterDialog>

      {/* increase / decrease book dialog */}
      <IncreaseDecreaseDialog
        open={state?.bookQuantityDialog}
        handleClose={() => {
          setState((prev) => ({ ...prev, bookQuantityDialog: false }));
        }}
        refetch={getBooksForSaleRefetch}
        bookDocId={state.bookDocId}
      />

      <BuyBookDialog
        open={state.addBookDialog}
        onClose={() => setState((prev) => ({ ...prev, addBookDialog: false }))}
        refetch={() => getBooksForSaleRefetch()}
        classData={getClassDropdownData}
      />
      {/* book detail dialog */}
      <Dialog
        open={dialogs?.view}
        onClose={() => {
          setDialogs((prev) => ({ ...prev, view: false }));
        }}
        PaperProps={{
          sx: { minWidth: { xs: "90%", md: 500, lg: 600 } },
        }}
      >
        <DialogHeader
          title="Book Detail"
          handleClose={() => {
            setDialogs((prev) => ({ ...prev, view: false }));
          }}
        />
        <DialogContent>
          <TextFieldLabel title="Book Detail" />
          <GrayBox>
            <Grid container rowGap={2}>
              <Grid item xs={isMobile ? 5 : 4}>
                <TextFieldLabel
                  title="Book title"
                  styleProps={{ fontSize: isMobile && "12px" }}
                />
                <Typography
                  sx={{ fontWeight: 700, fontSize: isMobile && "12px" }}
                >
                  {state?.active?.bookTitle}
                </Typography>
              </Grid>
              <Grid item xs={isMobile ? 5 : 4}>
                <TextFieldLabel
                  title="Class-Stream-Sec"
                  styleProps={{ fontSize: isMobile && "12px" }}
                />
                <Typography
                  sx={{ fontWeight: 700, fontSize: isMobile && "12px" }}
                >
                  {state?.active?.className}-{state?.active?.stream}-
                  {state?.active?.section}
                </Typography>
              </Grid>
              <Grid item xs={isMobile ? 5 : 4}>
                <TextFieldLabel
                  title="Reciept Detail"
                  styleProps={{ fontSize: isMobile && "12px" }}
                />
                {state?.active?.attachementUrl ? (
                  <a
                    href={state?.active?.attachementUrl}
                    style={{ color: "#1d8ba7" }}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Button
                      size="small"
                      color="secondary"
                      variant="contained"
                      sx={{ textTransform: "lowercase" }}
                    >
                      View
                    </Button>
                  </a>
                ) : (
                  <Typography>--</Typography>
                )}
              </Grid>
              <Grid item xs={isMobile ? 4 : 3}>
                <TextFieldLabel
                  title="Bought Qty"
                  styleProps={{ fontSize: isMobile && "12px" }}
                />
                <Typography
                  sx={{ fontWeight: 700, fontSize: isMobile && "12px" }}
                >
                  {state?.active?.quantity}
                </Typography>
              </Grid>
              <Grid item xs={isMobile ? 5 : 3}>
                <TextFieldLabel
                  title="Buying Rate"
                  styleProps={{ fontSize: isMobile && "12px" }}
                />
                <Stack direction={"row"} gap={1}>
                  <Typography
                    sx={{ fontWeight: 700, fontSize: isMobile && "12px" }}
                  >
                    {IndianCurrency(state?.active?.buyingRate)}
                  </Typography>
                  <Box
                    onClick={() => handleEditRateDialog(state?.active)}
                    sx={{ cursor: "pointer" }}
                  >
                    <img
                      alt="edit"
                      src="/edit-icon.png"
                      style={{
                        height: "20px",
                        width: "20px",
                        objectFit: "contain",
                      }}
                    />
                  </Box>
                </Stack>
              </Grid>
              <Grid item xs={isMobile ? 5 : 3}>
                <TextFieldLabel
                  title="Sold Quantity"
                  styleProps={{ fontSize: isMobile && "12px" }}
                />
                <Typography
                  sx={{ fontWeight: 700, fontSize: isMobile && "12px" }}
                >
                  {state?.active?.soldQuantity
                    ? state?.active?.soldQuantity
                    : "--"}
                </Typography>
              </Grid>
              <Grid item xs={isMobile ? 5 : 3}>
                <TextFieldLabel
                  title="Selling Rate"
                  styleProps={{ fontSize: isMobile && "12px" }}
                />
                <Stack direction={"row"} gap={1}>
                  <Typography
                    sx={{ fontWeight: 700, fontSize: isMobile && "12px" }}
                  >
                    {IndianCurrency(state?.active?.sellingRate)}
                  </Typography>
                  <Box
                    onClick={() => handleEditRateDialog(state?.active)}
                    sx={{ cursor: "pointer" }}
                  >
                    <img
                      alt="edit"
                      src="/edit-icon.png"
                      style={{
                        height: "20px",
                        width: "20px",
                        objectFit: "contain",
                      }}
                    />
                  </Box>
                </Stack>
              </Grid>
            </Grid>
          </GrayBox>
          <TextFieldLabel mt={2} title="Seller Detail" />
          <GrayBox>
            <Grid container rowGap={2}>
              <Grid item xs={isMobile ? 5 : 3}>
                <TextFieldLabel
                  title="Seller Name"
                  styleProps={{ fontSize: isMobile && "12px" }}
                />
                <Typography
                  sx={{ fontWeight: 700, fontSize: isMobile && "12px" }}
                >
                  {" "}
                  {state?.active?.bookSellerDetail?.firmName
                    ? state?.active?.bookSellerDetail?.firmName
                    : "--"}
                </Typography>
              </Grid>
              <Grid item xs={isMobile ? 5 : 4}>
                <TextFieldLabel
                  title="Mobile Number"
                  styleProps={{ fontSize: isMobile && "12px" }}
                />
                <Typography
                  sx={{ fontWeight: 700, fontSize: isMobile && "12px" }}
                >
                  {state?.active?.bookSellerDetail?.mobileNumber
                    ? state?.active?.bookSellerDetail?.mobileNumber
                    : "--"}
                </Typography>
              </Grid>
              <Grid item xs={5}>
                <TextFieldLabel
                  title="Alternate Mobile Number"
                  styleProps={{ fontSize: isMobile && "12px" }}
                />
                <Typography
                  sx={{ fontWeight: 700, fontSize: isMobile && "12px" }}
                >
                  {" "}
                  {state?.active?.bookSellerDetail?.alternateMobileNumber
                    ? state?.active?.bookSellerDetail?.alternateMobileNumber
                    : "--"}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <TextFieldLabel
                  title="Address"
                  styleProps={{ fontSize: isMobile && "12px" }}
                />
                <Typography
                  sx={{ fontWeight: 700, fontSize: isMobile && "12px" }}
                >
                  {state?.active?.bookSellerDetail?.permanentAddress?.address},{" "}
                  {state?.active?.bookSellerDetail?.permanentAddress?.dist},{" "}
                  {state?.active?.bookSellerDetail?.permanentAddress?.state},
                  {state?.active?.bookSellerDetail?.permanentAddress?.state}`
                </Typography>
              </Grid>
            </Grid>
          </GrayBox>
        </DialogContent>
      </Dialog>
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <FilterButton
          count={
            Object.values(checkboxes).filter((item) => item === true).length
          }
          handleClick={() => setModalOpen(true)}
        />

        <Stack direction={"row"} gap={2} alignItems={"center"}>
          <Button
            onClick={() => {
              setState((prev) => ({ ...prev, addBookDialog: true }));
            }}
            variant="outlined"
            color="secondary"
            size="large"
            sx={{ fontSize: { xs: "0.9rem", md: "1.2rem" } }}
          >
            + Add Books
          </Button>
          <Box sx={{ mt: "-10px" }}>
            <ExportButtonGroup
              handleClickExcel={() => setOpenCheckBox(true)}
              showPdf={true}
              handleClickPdf={() =>
                setState((prev) => ({
                  ...prev,
                  checkExportOptionsPdf: true,
                }))
              }
            />
          </Box>
        </Stack>
      </Stack>
      <Stack mt={3}>
        <CommonTable1 columns={columns} data={tableData} maxHeight="67vh" />
      </Stack>
    </>
  );
};

export default BookSummary;


const GrayBox = styled(Box)(({ theme }) => ({
  backgroundColor: "#f8fbff",
  border: "1px solid rgba(61, 57, 137, 0.1)",
  boxShadow: "0px 4px 10px rgba(61, 57, 137, 0.05)",
  borderRadius: "20px",
  padding: "10px",
}));

